import TrashLocations from './TrashLocations';

export default TrashLocations;
